import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL, URLS } from "../../_config";
import { useRole, useToken } from "../../_common/hooks/authHook";
import { showDate } from "../../_common/functions";
import Nav from "../../components/layouts/nav";
import Footer from "../../components/layouts/footer";

const CustomersList = () => {
    const tokenData: any = useToken();
    const userRole: any = useRole();
    const navigate: any = useNavigate();

    const [customers, setCustomers] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        if (userRole && userRole !== 'marketer') {
            navigate(URLS.ACCOUNT.MY_BUSINESS_PLAN);
        }
    }, [userRole]);

    const fetchCustomers = async (page: number = 1) => {
        try {
            setLoading(true);
            const response = await fetch(`${API_URL.MARKETER.CUSTOMERS}?page=${page}&per_page=20`, {
                headers: { Authorization: `Bearer ${tokenData}` },
            });
            const resp = await response.json();
            if (resp?.data) {
                setCustomers(resp.data.customers);
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (tokenData) {
            fetchCustomers(currentPage);
        }
    }, [currentPage, tokenData]);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const paymentStatusBadge = (status: string) => {
        if (status === 'Paid') return <span className="badge bg-success">Paid</span>;
        return <span className="badge bg-warning text-dark">Unpaid</span>;
    };

    return (
        <>
            <Nav />
            <div className="body-part gray-bg mt-105">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className="section-title mb-4">My Customers</h2>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card shadow-sm">
                                <div className="card-body p-0">
                                    {loading ? (
                                        <div className="text-center py-5">Loading...</div>
                                    ) : customers?.data?.length === 0 ? (
                                        <div className="text-center py-5 text-muted">No customers found.</div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-hover mb-0">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Client ID</th>
                                                        <th>Service</th>
                                                        <th>Date</th>
                                                        <th>Your Commission</th>
                                                        <th>Payment Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {customers?.data?.map((row: any) => (
                                                        <tr key={row.user_customer_id}>
                                                            <td>{row.client_id}</td>
                                                            <td>{row.service || '—'}</td>
                                                            <td>{row.payment_date ? showDate(row.payment_date) : '—'}</td>
                                                            <td>
                                                                {row.commissions?.length > 0
                                                                    ? row.commissions.map((c: any, i: number) => (
                                                                        <div key={i}>{c.amount} {c.currency || ''}</div>
                                                                      ))
                                                                    : '—'}
                                                            </td>
                                                            <td>{paymentStatusBadge(row.payment_status)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="d-flex justify-content-start mt-2">
                                <p className="text-muted fw-normal">Total: {customers?.total}</p>
                            </div>
                            {customers && customers.last_page > 1 && (
                                <div className="d-flex justify-content-center mt-4">
                                    <nav>
                                        <ul className="pagination">
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                                            </li>
                                            {Array.from({ length: customers.last_page }, (_, i) => i + 1).map(page => (
                                                <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                                    <button className="page-link" onClick={() => handlePageChange(page)}>{page}</button>
                                                </li>
                                            ))}
                                            <li className={`page-item ${currentPage === customers.last_page ? 'disabled' : ''}`}>
                                                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default CustomersList;
